import { render, staticRenderFns } from "./TareasForm.vue?vue&type=template&id=6f3aea71&"
import script from "./TareasForm.vue?vue&type=script&lang=js&"
export * from "./TareasForm.vue?vue&type=script&lang=js&"
import style0 from "./TareasForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports